import md5 from 'blueimp-md5'; // 小程序里也可以用 CryptoJS 或自定义 md5 库
import CryptoJS from 'crypto-js';

export function formatNumber (n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}
export function generateSign(params) {
  const keys = Object.keys(params).sort();
  let str = '';
  keys.forEach(key => {
    if (params[key] !== undefined && params[key] !== '') {
      str += key + '=' + params[key] + '&';
    }
  });
  str += 'key=mC0KHp469Mx0TacjqCh2rpKmwIEnavGm'; // 加上约定好的密钥
  return md5(str).toUpperCase();
}
export function generateSHA256Sign(params) {
  const keys = Object.keys(params).sort();
  let str = '';
  keys.forEach(key => {
    if (params[key] !== undefined && params[key] !== '') {
      str += key + '=' + params[key] + '&';
    }
  });
  str += 'key=mC0KHp469Mx0TacjqCh2rpKmwIEnavGm';
  // console.log(str);
  return CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex).toUpperCase();
}
export function generateNonce(length = 32) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let nonce = '';
  for (let i = 0; i < length; i++) {
    nonce += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return nonce;
}

export function formatTime (date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  const t1 = [year, month, day].map(formatNumber).join('/')
  const t2 = [hour, minute, second].map(formatNumber).join(':')

  return `${t1} ${t2}`
}
export function uniquesArr(obj) {
  var uniques = [];
  var stringify = {};
  for (var i = 0; i < obj.length; i++) {
      var keys = Object.keys(obj[i]);
      keys.sort(function(a, b) {
          return (Number(a) - Number(b));
      });
      var str = '';
      for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
      }
      if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
      }
  }
  uniques = uniques;
  return uniques;
}




// WEBPACK FOOTER //
// ./src/utils/index.js